import React from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route
} from 'react-router-dom';
import Home from './components/Home/Home';
import TravelHome from './components/Travel/Home/TravelHome';
import CssBaseline from '@material-ui/core/CssBaseline';
import { ThemeProvider } from '@material-ui/core/styles';
import theme from './theme';
import AccountCreationPage from "./components/AccountCreation/AccountCreationPage";

const App : React.FC = () => (
  <ThemeProvider theme={theme}>
    
    <CssBaseline />

    <Router basename="onboarding">
      <Switch>
        <Route exact path="/" component={Home} />
        <Route exact path="/accounts" component={AccountCreationPage} />
      </Switch>
    </Router>
  
  
  </ThemeProvider>
)

export default App;
